var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styles from './FloatLabel.module.scss';
var FloatLabel = function (_a) {
    var children = _a.children, label = _a.label, text = _a.text, props = __rest(_a, ["children", "label", "text"]);
    var _b = useState(false), focus = _b[0], setFocus = _b[1];
    var labelClass = focus || (text && text.length !== 0) ? [styles.label, styles.labelFloat].join(' ') : styles.label;
    var onBlur = function () { return setFocus(false); };
    var onFocus = function () { return setFocus(true); };
    return (_jsxs("div", __assign({ className: styles.floatLabel, onBlur: onBlur, onFocus: onFocus }, props, { children: [children, _jsx("label", __assign({ className: labelClass }, { children: label }))] })));
};
export default FloatLabel;
